import { getStatusCfg } from "@/lib/statusConfig";

interface Props {
  status: string | null | undefined;
  /** "xs" = compact (10px, tighter padding) | "sm" = default (12px) | "md" = larger (13px) */
  size?: "xs" | "sm" | "md";
  /** Show the icon to the left of the label */
  showIcon?: boolean;
  /** Extra Tailwind classes appended to the pill */
  className?: string;
}

/**
 * Unified status badge for all entity states.
 *
 * Usage:
 *   <StatusBadge status={client.status} />
 *   <StatusBadge status={job.status} size="xs" showIcon={false} />
 *   <StatusBadge status="published" />
 */
export default function StatusBadge({
  status,
  size      = "sm",
  showIcon  = true,
  className = "",
}: Props) {
  const cfg = getStatusCfg(status);

  const sizeClasses = {
    xs: "px-2 py-0.5 text-[10px] gap-1",
    sm: "px-2.5 py-0.5 text-xs gap-1.5",
    md: "px-3 py-1 text-xs gap-1.5",
  }[size];

  const iconSize = {
    xs: "text-[9px]",
    sm: "text-[10px]",
    md: "text-[11px]",
  }[size];

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full whitespace-nowrap capitalize ${sizeClasses} ${cfg.badge} ${className}`}
    >
      {showIcon && (
        <span className={`flex items-center justify-center flex-shrink-0 ${iconSize}`}>
          <i className={cfg.icon}></i>
        </span>
      )}
      {cfg.label}
    </span>
  );
}
